"use client";

import Image from "next/image";
import CTA from "./ui/CTA";

interface TeamMemberProps {
  id: string;
  name: string;
  role: string;
  location: string;
  image: string;
  locationImage: string;
  emoji: string;
  emojiLabel: string;
  slug: string;
}

export default function TeamMember({
  name,
  role,
  location,
  image,
  locationImage,
  emoji,
  emojiLabel,
  slug,
}: TeamMemberProps) {
  return (
    <div className="py-4">
      <div>
        {/* Images */}
        <div className="relative h-[150px] xl:h-[200px]">
          <div
            className="mt-2 border-4 border-tan overflow-hidden 
                       inline-block absolute top-0 w-[150px] xl:w-[200px] z-10
                       rounded-full transition-all duration-300"
          >
            <Image
              src={image}
              alt={name}
              width={200}
              height={200}
              className="w-full"
            />
          </div>

          <div
            className="overflow-hidden
                       inline-block absolute top-0 left-32 
                       w-[150px] xl:w-[200px] z-0
                       transition-opacity duration-300"
          >
            <Image src={locationImage} alt={name} width={300} height={300} />
          </div>
        </div>

        {/* Info */}
        <h2 className="mt-2 flex text-2xl lg:text-4xl gap-2 items-center relative z-20">
          {name}
          <div>
            <div
              className="rounded-full flex w-8 h-8 bg-[rgba(0,0,0,.1)]
                         text-sm relative justify-center items-center"
              role="tooltip"
              aria-label={emojiLabel}
            >
              <span aria-hidden="true">{emoji}</span>
            </div>
          </div>
        </h2>

        <h3 className="text-base lg:text-xl mt-2">
          {role} / {location}
        </h3>
      </div>

      <CTA href={`/team/${slug}`} className="mt-4 text-base lg:text-lg">
        Meet {name.split(" ")[0]}
      </CTA>
    </div>
  );
}
